<template>

    <div class='divText'>
        <h1>{{Text}}</h1>
    </div>
    
</template>

<script>
    export default {
         props: {
             Text: {
                 type: String,
             },
         },
    }
</script>

<style lang="css" scoped>
.divText{
    margin-left:auto;
    margin-right:auto;
    text-align: center;
    padding: 2rem 2rem;
}

h1 {
  font-size: 1rem;
  font-weight:900;
  padding-top:0%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}
</style>